<template>
  <div class="module-administrator">
    <div class="module-administrator-container">
      <div class="left-container">
        <div class="module-title">模块管理员</div>
        <div
          :class="activeIndex === index?'active role':'role'"
          v-for="(item, index) in roleList"
          :key="index"
          @click="selectRoleId(item, index)"
        >
          <span class="img"></span>
          <span class="role-name">{{ item.roleName }}</span>
        </div>
      </div>
      <div class="right-container">
        <div class="top-container" v-if="roleName">
          <div class="title">{{ roleName }}</div>
          <div class="search">
            <el-button
              v-if="activeName == 'role'&&
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleSubAdminUserManage
                ) !== -1
              "
              type="text"
              class="btn-blue add"
              @click="add"
              >添加成员</el-button>
            <el-button
              v-if="activeName != 'role'&&
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleSubAdminAuthorityManage
                ) !== -1
              "
              type="text"
              class="btn-blue add"
              @click="saveAuthority"
              >保存</el-button>
          </div>
        </div>
        <div v-if="roleName" class="authority">
          <el-input
            v-if="activeName == 'role'"
            class="gray white search-staff"
            placeholder="搜索员工名"
            prefix-icon="el-icon-search"
            v-model="searchStaff"
            clearable
            @keyup.enter.native="searchPeople"
          >
          </el-input>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="角色成员" name="role">
              <div class="table" v-if="tableData.length > 0">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column
                    v-for="(item, index) in tableTitleList"
                    :key="index"
                    :prop="item.prop"
                    :label="item.lable"
                    :width="item.width"
                  />
                  <el-table-column label="数据范围">
                    <template slot-scope="scope">
                      <el-tooltip
                        v-if="scope.row.controlLimit != '—'"
                        effect="dark"
                        placement="top">
                        <div slot="content">
                          <div v-for="(item,index) in scope.row.dataRangeList" :key="index">
                            {{ item.name }}
                            <br />
                          </div>
                        </div>
                        <p >{{ scope.row.controlLimit }}</p>
                      </el-tooltip>
                      <p v-else>{{ scope.row.controlLimit }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="120"
                    v-if="
                      OPERATION_LIST.findIndex(
                        (item) => item === OPERATIONS_BTNS.roleSubAdminUserManage
                      ) !== -1
                    "
                  >
                    <template slot-scope="scope">
                      <i class="el-icon-delete" @click="remove(scope.row)"></i>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="pagination-tpl-container">
                  <pagination-tpl
                    :total="totalNum"
                    :currentPage="currentPage"
                    @queryChange="onQueryChange"
                  ></pagination-tpl>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="权限配置" name="authority">
              <div class="table">
                <el-table :data="lists" style="width: 100%">
                  <el-table-column label="页面权限" width="250">
                    <template slot-scope="scope">
                      <div class="page-container">
                        <el-checkbox
                          :indeterminate="scope.row.isIndeterminate"
                          v-model="scope.row.checkAll"
                          @change="handleCheckAllChange(scope.$index,scope.row.checkAll)"
                        >{{scope.row.title}}</el-checkbox>
                        <i v-if="scope.row.checkAll&&scope.row.keyword == 'ROLE_BizRole'" class="el-icon-view" @click="openSelectRole(scope.$index, scope.row.isOpenSelectRole)"></i>
                        <div class="select-role-container" v-if="scope.row.isOpenSelectRole">
                          <div class="select-role-title">
                            <p>查看角色</p>
                            <p v-if="selectBusinessRoleName" class="select-role-tag">{{selectBusinessRoleName}}</p>
                            <p v-if="selectBusinessRoleList.length > 0">+{{selectBusinessRoleList.length}}</p>
                          </div>
                          <el-checkbox-group
                            v-model="selectBusinessRoleList"
                            @change="changeSelectBusinessRoleList"
                          >
                            <el-checkbox
                              v-for="(item, index) in selectRoleList"
                              :label="item.roleId"
                              :key="index"
                            >{{item.roleName}}</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作权限" >
                    <template slot-scope="scope">
                      <div class="list-child">
                        <el-checkbox-group
                          v-model="scope.row.authority"
                        >
                          <el-checkbox
                            v-for="(child, index) in scope.row.children"
                            :label="child.id"
                            :key="index"
                            :disabled="!scope.row.checkAll?!scope.row.checkAll:child.checkAll"
                          >{{child.name}}</el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        
        <div class="nothing" v-if="!roleName">
          <div class="nothing-left">
            <p>什么是模块管理员？</p>
            <ul>
              <li>
                为了提高财务数字化管理平台的管理效率，支队管理员可为
                各个模块设立专人管理，一人可兼任多个模块的管理工作。
              </li>
            </ul>
          </div>
          <div class="nothing-right">
            <div>
              <img src="../../../assets/module-nothing.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加角色成员 -->
    <el-dialog
      class="add-people"
      title="添加成员配置"
      :visible.sync="dialogVisible"
      width="940px"
      :before-close="addPeopleClose"
    >
      <div>
        <div class="top-container">
          <el-steps :active="setpsActive" align-center>
            <el-step title="添加角色成员"></el-step>
            <el-step title="通讯录权限配置"></el-step>
            <el-step v-if="moduleType == 'food'" title="数据范围配置"></el-step>
          </el-steps>
        </div>
        <div v-if="setpsActive == 1">
          <div class="stayDistribution">
            <div class="table-right">
              <p class="title">每次最多可添加一名成员</p>
              <div class="tree-container">
                <tree
                  :isSearch="isSearch"
                  :companyList="companyList"
                  :departmentId="departmentId"
                  @selectTreeNodeList="selectTreeNodeList"
                />
              </div>
            </div>
            <div class="table table-left">
              <div class="search-table">
                <el-input
                  class="gray white"
                  @keyup.enter.native="initStaffList"
                  v-model="staff"
                  placeholder="请输入成员"
                ></el-input>
              </div>
              <el-table
                :data="assignPeople"
                style="width: 100%;"
                height="250"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="60" :selectable="checkSelectable"> </el-table-column>
                <el-table-column prop="name" label="姓名">
                  <template slot-scope="scope">
                    <div class="assign-name">
                      <img :src="scope.row.img">
                      <span>{{ scope.row.name }}</span>
                      <span v-if="scope.row.identity == 2">（借调）</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="departmentNameStr" label="所在部门" show-overflow-tooltip></el-table-column>
              </el-table>
              <div class="pagination-tpl-container">
                <pagination-tpl
                  :total="peopleTotalNum"
                  :currentPage="peopleCurrentPage"
                  @queryChange="peopleQueryChange"
                ></pagination-tpl>
              </div>
            </div>
          </div>
        </div>

        <!-- 通讯录范围 -->
        <div v-if="setpsActive == 2">
          <div class="department-content">
            <div class="select-container">
              <div class="department-list">
                <TreeCheckout
                  :companyList="departmentList"
                  :departmentId="selectDepartmentId"
                  :selectData="selectData"
                  @selectTreeNodeList="selectDepartmentHeadTreeNodeList"
                />
              </div>
            </div>
            <div class="border"></div>
            <div class="selected-container">
              <p class="label">已选：</p>
              <div class="selected-content">
                <ul class="selected-list">
                  <li
                    class="selected-item"
                    v-for="(value, index) in selectData"
                    :key="index"
                  >
                    <span class="selected-item-name">
                      <img :src="second" class="second">
                      {{ value.departmentName }}
                    </span>
                    <span class="remove" @click="removeSelectData(index)">移除</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 数据范围 -->
        <div class="modBillManagementScope" v-if="setpsActive == 3">
          <div class="select-bill-container">
            <div
              class="select-bill"
              v-for="(v,idx) in canteenList"
              :key="idx"
            >
              <el-checkbox-group v-model="selectCanteenList">
                <el-checkbox :label="v.id">{{v.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="setpsActive != 1" @click="back"
          >上一步</el-button
        >
        <el-button v-if="setpsActive != 1" type="primary" @click="addPeopleConfirm">确 定</el-button>
        <el-button v-if="setpsActive == 1" type="primary" @click="next">下一步</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import Tree from "@/components/Tree.vue";
import TreeCheckout from "@/components/tree/tree-checkout.vue";
import PaginationTpl from "@/components/PaginationTpl.vue";
import Staff from "@/models/staff.js";
import Canteen from "@/models/canteen.js";
import Administrator from "@/models/administrator.js";
import { operationMixins } from '@/common/mixins/operation/operation.js'
import { mapChild, mapId2, mapChildThirdDisable } from "@/common/js/utils.js";
import { saveTwolevelAuthrity, getTeamId } from "@/common/js/storage";
export default {
  inject: ['reload'],
  mixins: [operationMixins],
  components: {
    Tree,
    TreeCheckout,
    PaginationTpl
  },

  data() {
    return {
      avater: require("../../../assets/avater.png"),
      roleList: [],
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      tableTitleList: [
        { prop: "name", lable: "姓名", width: "" },
        { prop: "phone", lable: "手机号", width: "" },
        { prop: "department", lable: "所属部门", width: "" },
        { prop: "addressBook", lable: "通讯录范围", width: "" },
      ],
      roleName: "",
      searchStaff: "",
      activeIndex: "",
      dialogVisible: false,
      companyList: [],
      departmentList: [],
      departmentId: 0,
      selectType: null,
      selectRole: null,
      userId: null,
      setpsActive: 1,
      isSearch: false,
      staff: '',
      assignPeople:[],
      peopleTotalNum: 0,
      peopleCurrentPage: 1,

      selectDepartmentId: 0,
      selectDepartment: false,
      selectData: [],
      // 获取3级部门id
      parentId: '',
      second: require('../../../assets/tree/second.png'),
      /* 食堂集合 */
      canteenList: [],
      /* 选择的食堂集合 */
      selectCanteenList: [],
      /* 选择的用户id列表 */
      userIdList: [],

      activeName: 'role',
      lists: [],
      /* 所属模块类型 */
      moduleType: '',
      selectRoleList: [],
      /* 选择的业务角色 */
      selectBusinessRoleList: [],
      selectBusinessRoleName: '',
      timerId: null
    };
  },

  created() {
    config()
    this.initModuleAdministrator();
    this.initDepartmentList()
    this.initCanteenList()
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.emit("isShowTopMenu", false);
    });
  },
  beforeDestroy () {
    clearTimeout(this.timerId)
  },

  methods: {
    /* 获取角色用户列表 */
    initModuleAdministratorRoleType() {
      let userName = this.searchStaff
      let pageNo = this.currentPage
      let subAdminId = this.selectRole
      Administrator.getModuleAdministratorRoleType(subAdminId, userName, pageNo).then(res => {
        if (res.success) {
          this.totalNum = res.result.totalNum
          let arr = [];
          res.result.items.map((i) => {
            let obj = {};
            obj.subAdminUserId = i.subAdminUserId;
            obj.name = i.name ? i.name : "—";
            obj.phone = i.phoneNo ? i.phoneNo : "—";
            obj.department = i.deptName ? i.deptName : "—";
            obj.dataRangeList = i.dataRangeList
            obj.addressBookList = i.addressBookList
            let controlLimit = []
            let addressBook = []
            if (i.dataRangeList) {
              i.dataRangeList.map(v => {
                controlLimit.push(v.name)
              })
            }
            if (controlLimit.length > 0) {
              obj.controlLimit = controlLimit.join(';')
            } else {
              obj.controlLimit = "—";
            }
            if (i.addressBookList) {
              i.addressBookList.map(v => {
                addressBook.push(v.name)
              })
            }
            if (addressBook.length > 0) {
              obj.addressBook = addressBook.join(';')
            } else {
              obj.addressBook = "—";
            }
            arr.push(obj);
          });
          this.tableData = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取模块管理员/角色 */
    initModuleAdministrator() {
      Administrator.getModuleAdministrator().then(res => {
        if (res.success) {
          let arr = [];
          let selectRoleList = [];
          res.result.map((i) => {
            let obj = {};
            obj.roleId = i.roleId;
            obj.roleName = i.name;
            obj.type = i.type;
            obj.keyword = i.keyword;
            if (i.type == 1) {
              arr.push(obj);
            } else {
              selectRoleList.push(obj)
            }
          });
          this.roleList = arr;
          this.selectRoleList = selectRoleList;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取部门数据 */
    initDepartmentList() {
      let searchDepartment = ''
      let id = ''
      let keyword = ''
      Staff.getChangeDepartmentList(id, searchDepartment, keyword).then(res => {
        if (res.success) {
          let arr = mapChild(res.result);
          let arr2 = mapChildThirdDisable(res.result);
          this.companyList = mapId2(arr);
          if (this.companyList.length>0 && this.companyList[0].subList.length>0) {
            this.departmentId = this.companyList[0].subList[0].id
          }
          this.departmentList = arr2
          this.$bus.emit('initLeafKeys', this.departmentList)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    initStaffList() {
      let searchDepartment = this.staff
      let id = (this.departmentId != 0 && this.departmentId != 1)? this.departmentId: getTeamId()
      let currentPage = this.peopleCurrentPage
      Staff.getPeopleList(id, searchDepartment, currentPage).then(res => {
        if (res.success) {
          this.peopleTotalNum = res.result.totalNum
          let arr = [];
          res.result.items.map((i) => {
            let obj = {};
            obj.id = i.id;
            obj.name = i.name;
            obj.phone = i.phoneNo;
            obj.identity = i.identity;
            obj.departmentId = i.departmentId;
            obj.img = i.image ? i.image : this.avater;
            if (i.deptName) obj.departmentNameStr = `${i.groupName}/${i.deptName}`
            if (!i.deptName) obj.departmentNameStr = `${i.groupName}`
            arr.push(obj);
          });
          this.assignPeople = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取权限信息 */
    initModuleAdministratorAuthority() {
      let moduleType = this.moduleType
      Administrator.getModuleAdministratorAuthority(moduleType).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.title = value.name;
            obj.id = value.id;
            obj.keyword = value.keyword;
            obj.checkAll = false;
            obj.isIndeterminate = false;
            obj.isOpenSelectRole = false;
            obj.authority = [];
            obj.children = [];
            value.subList.map((value) => {
              let child = {};
              child.name = value.name;
              child.id = value.id;
              if (value.name == '创建食堂' || value.name == '删除食堂') {
                child.checkAll = true;
              } else {
                child.checkAll = false;
              }
              obj.children.push(child);
            });
            arr.push(obj);
          });
          this.lists = arr;
          this.initModuleAdministratorAuthorityDetails()
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /* 获取某模块管理员具有的权限 */
    initModuleAdministratorAuthorityDetails() {
      let subAdminId = this.selectRole
      Administrator.getModuleAdministratorAuthorityDetails(subAdminId).then(res => {
        if (res.success) {
          this.lists.map((i,index) => {
            res.result.map(v => {
              if (i.id == v.id) {
                this.$set(this.lists[index], 'checkAll', true);
                this.$set(this.lists[index], 'authority', v.subList);
              }
            })
          }) 
        } else {
          this.$message.error(res.message);
        }
      });
    },
    
    /* 可见的模块管理员和角色 */
    initModuleAdministratorRoleList() {
      let subAdminId = this.selectRole
      Administrator.getModuleAdministratorRoleList(subAdminId).then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            if (i.type == 2) {
              arr.push(i.id);
            }
          });
          this.selectBusinessRoleList = arr;
          this.changeSelectBusinessRoleList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取食堂数据 */
    initCanteenList() {
     Canteen.getCanteenNoPageList().then(res => {
       if (res.success) {
         let arr = []
         res.result.map(i => {
           let obj = {}
           obj.id = i.id
           obj.name = i.name
           arr.push(obj)
         })
         this.canteenList = arr
       } else {
         this.$message({
           type: "error",
           message: res.message,
         });
       }
     })
    },
    
    /* 全选函数 */
    handleCheckAllChange(index, val) {
      let arr = [];
      this.lists[index].children.map((value) => {
        if (value.name != '创建食堂' && value.name != '删除食堂') {
          arr.push(value.id);
        }
      });
      this.lists[index].authority = val ? arr : [];
      this.lists[index].isIndeterminate = false;
      this.lists.map(i => {
        if (i.keyword == 'ROLE_BizRole' && !i.checkAll) {
          this.selectBusinessRoleList = []
          this.selectBusinessRoleName = ''
          i.isOpenSelectRole = false
        }
      })
    },

    /* 选择业务角色 */
    changeSelectBusinessRoleList() {
      let selectBusinessRoleName = ''
      let id = this.selectBusinessRoleList.length > 0? this.selectBusinessRoleList[0] : 0
      if (id) selectBusinessRoleName = this.selectRoleList.find((ele) => ele.roleId == id).roleName;
      this.selectBusinessRoleName = selectBusinessRoleName
    },
    
    /* 打开角色选择 */
    openSelectRole(index, isOpenSelectRole) {
      this.lists[index].isOpenSelectRole = !isOpenSelectRole;
    },

    /* 获取权限 */
    initTwolevelAuthority() {
      Administrator.getTwolevelAuthority().then(res => {
        if (res.success) {
          saveTwolevelAuthrity(res.result);
          this.reload()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /* 保存权限 */
    saveAuthority() {
      let authorityList = []
      let roleList = this.selectBusinessRoleList
      this.lists.map(i => {
        if (i.checkAll) {
          let obj = {};
          obj.id = i.id;
          obj.subList = i.authority;
          authorityList.push(obj)
        }
      })

      let subAdminId = this.selectRole
      let data = {
        subAdminId,
        roleList,
        authorityList
      }
      Administrator.getSaveModuleAdministratorAuthority(data).then(res => {
        if (res.success) {
          this.initTwolevelAuthority()
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleClick(tab, event) {

    },

    searchPeople() {
      this.currentPage = 1;
      this.initModuleAdministratorRoleType();
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initModuleAdministratorRoleType();
    },

    peopleQueryChange(data) {
      this.peopleCurrentPage = data.currentPage;
      this.initStaffList();
    },

    /* 选择角色 */
    selectRoleId(row, index) {
      this.activeIndex = index
      this.roleName = row.roleName
      this.selectType = row.type
      this.selectRole = row.roleId
      this.moduleType = row.keyword
      this.initModuleAdministratorRoleType();
      this.initModuleAdministratorRoleList()
      this.initModuleAdministratorAuthority()
    },

    /* 删除角色用户 */
    _moduleAdministratorDelRoleType(data) {
      Administrator.postModuleAdministratorDelRoleType(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.initModuleAdministratorRoleType();
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    remove(row) {
      this.$confirm("角色成员删除后不可恢复，是否继续？", "确认删除成员", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let subAdminUserId = row.subAdminUserId
        let data = {
          subAdminUserId,
        }
        this._moduleAdministratorDelRoleType(data)
      });
    },
    
    /* ----------------------------------  以下是添加成员方法 ------------------------ */
    /* 添加 */
    add() {
      if (this.roleName) {
        this.userId = ''
        this.departmentId = (this.departmentId != 0 && this.departmentId != 1)? this.departmentId: getTeamId()
        this.$bus.emit('defaultSelectFristTwoDeptment', this.departmentId)
        this.initStaffList();
        this.dialogVisible = true
        
      } else {
        this.$message({
          type: 'error',
          message: '请先选择角色'
        });
      }
    },

    addPeopleClose() {
      this.setpsActive = 1
      this.staff = ''
      this.assignPeople = []
      this.selectData = []
      this.userIdList = []
      this.selectCanteenList = []
      this.dialogVisible = false;
      this.$bus.emit('clearSelect', 0)
    },

    addPeopleConfirm() {
      let subAdminId = this.selectRole
      let userList = this.userIdList
      let addressBookList = []
      let dataRangeList = []
      this.selectData.map(i => {
        addressBookList.push(i.id2)
      })
      let data = {
        subAdminId,
        userList,
        addressBookList,
        dataRangeList
      }
      if (this.setpsActive == 2) {
        if (this.selectData.length == 0) return this.$message.error('请选择通讯录范围')
        if (this.moduleType == 'food') {
          this.setpsActive++
          return
        } else {
          this._postSaveRoleType(data)
        }
      }
      if (this.setpsActive == 3) {
        if (this.selectCanteenList.length > 1) return this.$message.error('只能选择一个数据范围')
        data.dataRangeList = this.selectCanteenList
        this._postSaveRoleType(data)
      }
    },

    /* 添加角色用户 */
    _postSaveRoleType(data) {
     Administrator.postSaveRoleType(data).then(res => {
       if (res.success) {
          this.$message({
            type: 'success',
            message: '添加角色用户成功'
          });
          this.addPeopleClose()
          this.initModuleAdministratorRoleType()
       } else {
         this.$message({
           type: "error",
           message: res.message,
         });
       }
     })
    },

    /* 选择添加成员所在部门 */
    selectTreeNodeList(v) {
      if (v.id != 1) {
        this.userIdList = []
        this.departmentId = v.id
        this.initStaffList()
      }
    },

    /* 
      判断是否可以多选若返回为 true,
      则可以选中，否则禁止选中
    */
    checkSelectable(row) {
      return row.identity == 1
    },

    /* 选择成员 */
    handleSelectionChange(v) {
      let arr = []
      v.map(i => {
        let obj = {
          userId: i.id,
          deptId: i.departmentId
        }
        arr.push(obj)
      })
      this.userIdList = arr
    },

    back() {
      this.setpsActive--
    },

    next() {
      if (this.setpsActive == 1) {
        if (this.userIdList.length == 0) return this.$message.error('请选择成员')
        this.setpsActive++
      }
    },

    /* 选择通讯录部门 */
    selectDepartmentHeadTreeNodeList(v) {
      let isFlag = false
      v.map(i => {
        if (this.selectData.length > 0 && this.parentId != i.parentId) {
          isFlag = true
        } else {
          if (i.level == 3) this.parentId = i.id
          if (i.level != 3) this.parentId = i.parentId
        }
      })
      if (isFlag) {
        let arr = []
        this.selectData.map(i => {
          arr.push(i.id)
        })
        this.timerId = setTimeout(() => {
          this.$bus.emit('clear', arr)
        },100)
        return this.$message.error('模块管理员只可管理一个三级部门')
      }
      this.selectData = v
    },

    /* 移除通讯录部门  */
    removeSelectData(index) {
      this.selectData.splice(index, 1);
      this.$bus.emit('del', this.selectData)
    },
  },
};
</script>

<style lang='scss' scoped>
.module-administrator {
  flex: 1;
  background: $bg-white;
  .module-administrator-container {
    display: flex;
    height: 100%;
  }
  .left-container {
    width: 288px;
    padding: 16px;
    box-sizing: border-box;
    border-right: 1px solid $bg-ShallowLightSnow;
    .role {
      height: 40px;
      padding: 0px 16px;
      font-size: $fs-small-l;
      @include flex-start;
      cursor: pointer;
      .img {
        width: 16px;
        height: 16px;
        margin-right: 20px;
        background: url("../../../assets/role.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .role-name {
        height: 40px;
        line-height: 40px;
        @include two-wrap-ellipsis(1);
      }
      &:hover {
        background: $bg-ChangeDepartmentHighTree;
        color: $color-ReddishBlue;
        .img {
          background: url("../../../assets/role-high.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .active {
      background: $bg-ChangeDepartmentHighTree;
      color: $color-ReddishBlue;
      .img {
        background: url("../../../assets/role-high.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
    .module-title {
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-LightGrey;
      text-align: left;
      margin-bottom: 15px;
      padding-left: 16px;
    }
  }
  .right-container {
    flex: 1;
    padding: 16px 20px;
    position: relative;
    .top-container {
      @include flex-between;
      margin-bottom: 20px;
      .title {
        padding-left: 10px;
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
        border-left: 4px solid $color-DeepReddishBlue;
      }
      .search {
        display: flex;
        .add {
          margin-left: 12px;
          padding: 0;
        }
      }
    }
    .nothing {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      @include flex-center;
      .nothing-left {
        width: 350px;
        margin-right: 30px;
        ul {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-grey;
          text-align: left;
          li {
            margin-bottom: 21px;
            line-height: 20px;
          }
        }
      }
      img {
        width: 237px;
        height: 158px;
      }
      p {
        text-align: left;
        font-size: 36px;
        font-weight: 400;
        color: $color-Step;
        margin-bottom: 24px;
      }
    }
    .controlLimit {
      color: $color-DeepReddishBlue;
      cursor: pointer;
    }
    .authority {
      position: relative;
      .search-staff {
        position: absolute;
        right: 0px;
        top: -6px;
        width: 200px;
      }
      .el-icon-delete {
        cursor: pointer;
      }
      .page-container {
        .el-icon-view {
          margin-left: 10px;
          cursor: pointer;
          &:hover {
            color: $color-DeepReddishBlue;
          }
        }
        .select-role-container {
          width: 240px;
          height: 250px;
          overflow-y: auto;
          padding: 14px 12px;
          position: absolute;
          top: 72%;
          left: 47%;
          background: $bg-white;
          box-shadow: 3px 1px 9px 1px $oa-mene-shadow;
          z-index: 99;
          .select-role-title {
            @include flex-start;
            height: 36px;
            border-radius: 4px;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-grey;
            border: 1px solid $bg-DeepReddishBlue;
            padding-left: 5px;
            .select-role-tag {
              min-width: 64px;
              max-width: 104px;
              height: 24px;
              line-height: 24px;
              padding: 0px 3px;
              font-size: $fs-small-m;
              background: $color-white;
              border: 1px solid $bg-Gainsboro;
              border-radius: 2px;
              margin-left: 10px;
              margin-right: 6px;
              text-align: center;
              @include two-wrap-ellipsis(1);
            }
          }
        }
      }
    }
  }
  .top-container {
    margin: 20px 0px;
  }
  .stayDistribution {
    display: flex;
    .table-left {
      width: 500px;
      padding: 0px 16px;
      border-left: 1px solid $bg-ShallowLightSnow;
      box-sizing: border-box;
      overflow: hidden;
      .search-table {
        margin-bottom: 16px;
      }
      .assign-name {
        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }
      }
    }
    .table-right {
      flex: 1;
      padding: 0px 16px;
      box-sizing: border-box;
      overflow: hidden;
      .title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        margin-bottom: 14px;
        text-align: left;
        padding-left: 7px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
      .tree-container {
        height: 300px;
        overflow-y: auto;
        @include scrollbarNotrack(0px);
      }
    }
  }
  
  .department-content {
    margin: 16px 20px;
    border: 1px solid $bg-ShallowLightSnow;
    display: flex;
    justify-content: space-between;
    overflow-y: auto;
    height: 350px;
    position: relative;
    .border {
      position: absolute;
      top: 0px;
      left: 50%;
      height: 350px;
      transform: translateX(-50%);
      width: 1px;
      background: $bg-ShallowLightSnow;
    }
    .select-container {
      width: 50%;
      height: 100%;
      overflow-y: auto;
      @include scrollbarNotrack(0px);
      .department-list {
        padding: 12px;
        box-sizing: border-box;
      }
    }
    .selected-container {
      flex: 1;
      padding: 12px;
      .label {
        text-align: left;
        height: 40px;
        line-height: 40px;
        font-size: $fs-medium-s;
      }
      .selected-content {
        padding: 12px;
        box-sizing: border-box;
        .selected-item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: $fs-small-l;
          color: $color-grey;
          .second {
            margin-right: 19px;
          }
          .selected-item-name {
            height: 14px;
            line-height: 14px;
          }
          .remove {
            color: #ed6767;
            cursor: pointer;
          }
        }
      }
    }
  }
  
  .modBillManagementScope {
    @include flex-column-start;
    height: 360px;
    padding: 21px;
    margin: 20px;
    box-sizing: border-box;
    border: 1px solid $bg-DoopLightSnow;
    overflow-y: auto;
    .select-bill-container {
      width: 100%;
      @include flex-start;
      flex-wrap: wrap;
      .select-bill {
        width: 32%;
        height: 36px;
        line-height: 36px;
        text-align: left;
        box-sizing: border-box;
        background: #F8F9FA;
        border-radius: 2px;
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-grey;
        padding-left: 12px;
        margin-bottom: 12px;
        margin-right: 16px;
      }
      .select-bill:nth-child(3n) {
        margin-right: 0px;
      }
    }
  }
}
</style>
<style lang="scss">
.module-administrator {
  .el-tabs__header {
    margin-bottom: 0px;
  }
  .el-tabs__nav-wrap::after {
    height: 1px;
  }
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: auto;
  }
  .el-tabs__content,
  .el-table,
  .el-table__body-wrapper {
    overflow: inherit;
  }
  .add-people {
    .el-dialog__footer {
      @include flex-end;
    }
    .select-bill {
      .el-checkbox {
        @include flex-start;
        height: 36px;
        .el-checkbox__label {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical
        }
      }
    }
  }
  .stayDistribution {
    .table-left {
      .el-table {
        overflow-y: auto;
      }
    }
  }
  .search-staff {
    .el-input__prefix, .el-input__suffix {
      top: 3px;
    }
  }
}
</style>
